import React from 'react';
import { XIcon, SparklesIcon } from 'lucide-react';
import ReactMarkdown from 'react-markdown';

interface AIInsightsModalProps {
  isOpen: boolean;
  onClose: () => void;
  insights: string;
  isLoading: boolean;
}

export const AIInsightsModal: React.FC<AIInsightsModalProps> = ({ isOpen, onClose, insights, isLoading }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden animate-in fade-in zoom-in duration-200">
        
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b bg-gradient-to-r from-blue-50 to-indigo-50">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
              <SparklesIcon size={24} className={isLoading ? "animate-spin" : ""} />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">AI Business Insights</h2>
              <p className="text-sm text-gray-500">Powered by Gemini AI</p>
            </div>
          </div>
          <button 
            onClick={onClose}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <XIcon size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {isLoading ? (
            <div className="flex flex-col items-center justify-center h-64 text-center">
              <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4"></div>
              <h3 className="text-lg font-semibold text-gray-900">Analyzing your data...</h3>
              <p className="text-gray-500 max-w-sm mt-2">
                Our AI is reviewing your revenue, top products, and seasonal trends to generate personalized recommendations.
              </p>
            </div>
          ) : insights ? (
            <div className="prose prose-blue max-w-none bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <ReactMarkdown>{insights}</ReactMarkdown>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center h-64 text-center">
              <p className="text-gray-500">No insights available. Please try again.</p>
            </div>
          )}
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 border-t bg-white flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
